/**
 * PROTOTYPE project-level options (Platform + Retention) -- THROWAWAY.
 *
 * These are request-level inputs, not module config: platform users + whether CRCE provides
 * infra / support, and the retention tier + years. They map onto numberOfUsers,
 * customerManagedCloud, retentionTier and retentionYears (see spreadPricingApi).
 */

export type RetentionTier = 'none' | 'cold' | 'warm';

export interface PlatformOptions { users: number; infra: boolean; support: boolean; }
export interface RetentionOptions { tier: RetentionTier; years: number; }

export const DEFAULT_PLATFORM_OPTIONS: PlatformOptions = { users: 25, infra: true, support: true };
export const DEFAULT_RETENTION_OPTIONS: RetentionOptions = { tier: 'cold', years: 5 };
